import logo from '@/assets/landing/images/logo.svg';

export function LegalHeader() {
  return (
    <header className="bg-highlight px-4 py-3">
      <div className="landing-container flex items-center justify-between">
        <a href="/" className="flex items-center">
          <img src={logo} alt="Culture Monitor" className="w-8 h-8" />
        </a>
        <a
          href="https://live.tt/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-800 font-medium text-sm"
        >
          Sobre a LIVE
        </a>
      </div>
    </header>
  );
}
